import React, { useEffect, useRef, useState } from 'react';
import PanelWrapper from "../../meta/PanelWrapper";
import PanelTitle from "../../meta/PanelTitle";
import PanelContent from "../../meta/PanelContent";
import { CanteenAPIResponse } from "./types/canteenAPI";
import { Leaf, Plant, Bone, Record, Fish, ForkKnife } from "@phosphor-icons/react";
import ProgressBar from "../../meta/ProgressBar";

type Dish = {
  name: string,
  details: string,
  typeIcons: React.FC<any>[],
  price: {
    "student": string,
    "staff": string,
    "guest": string
  },
}

type MensaPanelDefinition = {
  canteenId: number,
  closingTime: {
    hours: number,
    minutes: number
  }
}

const MensaplanPanel = (props: { definition: MensaPanelDefinition }) => {
  const menus = useRef<Dish[]>([]);
  const specials = useRef<Dish[]>([]);
  const qspecials = useRef<Dish[]>([]);
  const [relativeDay, setRelativeDay] = useState<string>("heute");
  const [groupName, setGroupName] = useState<string>("Mensa")
  const cycle = useRef<number>(0);
  const [dishes, setDishes] = useState<Dish[]>([]);
  const [updateKey, setUpdateKey] = useState(Date.now());

  useEffect(() => {
    const update = async () => {
      try {
        // Determine day to fetch for
        const now = new Date();
        let fetchFor: string;

        if (
          now.getHours() > props.definition.closingTime.hours || (
            now.getHours() === props.definition.closingTime.hours &&
            now.getMinutes() > props.definition.closingTime.minutes
          )
        ) {
          // After closing, fetch for next day
          setRelativeDay("morgen");
          const tomorrow = new Date(now.setTime(now.getTime() + 24 * 60 * 60 * 1000));
          fetchFor = toRUBDate(tomorrow);
        } else {
          // otherwise, fetch for today
          setRelativeDay("heute");
          fetchFor = toRUBDate(now);
        }


        // Request the API
        const request = await fetch(`https://api-app.asta-bochum.de/get_meal/${props.definition.canteenId}`);
        const request2 = await fetch(`https://api-app.asta-bochum.de/get_meal/2`);
        const request3 = await fetch(`https://api-app.asta-bochum.de/get_meal/3`);

        if (request.status !== 200) {
          menus.current = [];
          specials.current = [];
          return;
        }

        let dataq = await request.json() as CanteenAPIResponse;
        const data = dataq.data[fetchFor] as unknown as any

        let dataq2 = await request2.json() as CanteenAPIResponse;
        const data2 = dataq2.data[fetchFor] as unknown as any

        // for some reason the api uses another format than the other apis
        // this is a quick and "easy" workaround
        let dataq3 = await request3.json();
        for (let d = 0; d < Object.keys(dataq3.data).length; d++) {
          let items = dataq3.data[Object.keys(dataq3.data)[d]];
          let day = Object();
          for (let i = 0; i < items.length; i++) {
            day[`${i}`] = [items[i]];
          }
          dataq3.data[Object.keys(dataq3.data)[d]] = day;
        }
        dataq3 = dataq3 as CanteenAPIResponse;
        const data3 = dataq3.data[fetchFor] as unknown as any

        const old_menus_count = menus.current.length;
        const old_specials_count = menus.current.length;
        // ToDo: This needs to be cleaned up!
        Object.entries(data)
          //@ts-ignore
          .filter(([k, v]) => k !== "Nudeltheke")
          //@ts-ignore

          .filter(([k, v]) => k !== "Döner")
          .filter(([k, v]) => k !== "Beilagen")
          // .sort((a, b) => {
          //   return a.position - b.position
          // })
          .map(([k, d]) => {
            //@ts-ignore
            d.forEach((itm) => {
              menus.current.push({
                name: itm.title,
                price: { student: itm.price.split(" / ")[0], staff: itm.price.split(" / ")[1], guest: itm.price.split(" / ")[1] },
                typeIcons: [],
                details: itm.allergies
              })
            })
          }
            // d.forEach((itm) => ({
            //     // @ts-ignore
            //     name: (d.title 
            //       .split(" | ")
            //       .at(0) ?? "Name nicht bekannt")
            //       .replace(" nach Wahl", "")
            //       .replaceAll(/\(.*\)/g, ""),
            //       // @ts-ignore
            //     details: d.title
            //       .split(" | ")
            //       .slice(1, -1)
            //       .join(", ")
            //       .replace(" nach Wahl", "")
            //       .replaceAll(/\(.*\)/g, ""),
            //       // @ts-ignore
            //     typeIcons: d.type.map(typeToIcon).filter(i => i !== null) as unknown as React.FC<any>[],
            //     // @ts-ignore
            //     price: d.price
            // }))
          )
        
        Object.entries(data2)
          .filter(([k, v]) => k !== "Kuchen")
          .filter(([k, v]) => k !== "Dessert")
          .map(([k, d]) => {
            //@ts-ignore
            d.forEach((itm) => {
              specials.current.push({
                name: itm.title,
                price: { student: itm.price.split(" / ")[0], staff: itm.price.split(" / ")[1], guest: itm.price.split(" / ")[1] },
                typeIcons: [],
                details: itm.allergies
              })
            })
          })

          Object.entries(data3)
          .map(([k, d]) => {
            //@ts-ignore
            d.forEach((itm) => {
              qspecials.current.push({
                name: itm.title,
                price: { student: itm.price.split(" | ")[0], staff: itm.price.split(" | ")[1], guest: itm.price.split(" | ")[1] },
                typeIcons: [],
                details: itm.allergies
              })
            })
          })
        // If the count of menus and specials changed, reset the cycler
        if (menus.current.length !== old_menus_count || specials.current.length !== old_specials_count) {
          setDishes(menus.current);
          setUpdateKey(Date.now());

          cycle.current = 0;
          setGroupName("Mensa")
        }
      }
      catch (e) {
        console.warn("MensaPlan not showing data because", e);
        menus.current = [];
        specials.current = [];
      }
    }

    update();
    const interval = setInterval(update, 1 * 60 * 60 * 1000);

    return () => {
      clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateGroup = () => {
    cycle.current = (cycle.current + 1) % 3;
    switch (cycle.current) {
      case 0:
        setGroupName("Mensa");
        setDishes(menus.current);
        break;
      case 1:
        setGroupName("Rote Bete");
        setDishes(specials.current);
        break;
        case 2:
          setGroupName("Q-West");
          setDishes(qspecials.current);
          break;
      default:
        console.error("You fucked up bad!");
        break;
    }
  }


  return (
    <PanelWrapper>
      <PanelTitle title={"Mensaplan für " + relativeDay} info={groupName} />
      <PanelContent autoScroll={true} key={updateKey}>
        <div className={"grid gap-y-1 gap-x-1.5"} style={{ gridTemplateColumns: "1fr 10fr 1fr" }}>
          {dishes.map(dish => (
            <>
              {/* Fixme: This shifts the name out of line if there is more than one */}
              <div className={"flex flex-row gap-1.5"}>
                {dish.typeIcons.map((Icon) => (
                  <Icon key={Icon.name} size={32} className={"text-zinc-400"} />
                ))}
              </div>

              <h3 className={"text-xl leading-tight scroll-snap-identifier"}>
                {dish.name}
              </h3>

              <p className={"text-sm text-zinc-400 leading-tight text-right"}>
                {dish.price.student}
              </p>

              <div>
              </div>

              <p className={"text-sm text-zinc-400 leading-tight col-span-2 mb-4"}>
                {dish.details}
              </p>
            </>
          ))}
        </div>

        {
          dishes.length === 0 && (
            <div className={"h-full w-full flex justify-center items-center"}>
              <div className={"mb-10 flex flex-col items-center"}>
                <ForkKnife size={48} className={"mb-3"} />
                <p className={"text-center text-zinc-400"}>
                  Es werden keine Gerichte in dieser Kategorie angeboten
                </p>
              </div>
            </div>
          )}
      </PanelContent>
      <ProgressBar duration={20000} idName={'mena-progress'} callbackFunction={updateGroup} />
    </PanelWrapper>
  );
};

export default MensaplanPanel;

function toYYYYMMDD(input: Date): string {
  return `${input.getFullYear().toString().padStart(4, "20")}-${(input.getMonth() + 1).toString().padStart(2, "0")}-${input.getDate().toString().padStart(2, "0")}`
}
function toRUBDate(input: Date): string {
  return input.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }).replace(".,", ",")
}
function typeToIcon(type: string): React.FC | null {
  switch (type) {
    case "N":
      // Vegan
      return Plant
    case "V":
      // Vegetarisch
      return Leaf
    case "G":
      // Geflügel
      return Bone
    case "K":
      // Kosher
      // ToDo: Work out proper icon
      return Record
    case "S":
      // Schwein
      return Bone
    case "R":
      // Rind (geraten)
      return Bone
    case "W":
      // Wild
      return Bone
    case "F":
      // Fisch (geraten)
      return Fish
    default:
      return null
  }
}
